export const calculateMaxPoints = () => {
    return 0;
}
